/**
 * Максимальное количество документов, отображаемых по умолчанию
 * Все отсальные документы свернуты если rollup = true
 */
const MAX_DOCUMENTS_COUNT = 6;
const MAX_DOCUMENTS_COUNT_LAPTOP = 4;
const MAX_DOCUMENTS_COUNT_MOBILE = 2;

/**
 * Функция для получения максимального количетсва документов, для отображения их по умолчанию
 * Кол-во документов меняется при адаптиве
 */
export function getDocumentsCount(isMobileWidth: boolean, isLaptopWidth: boolean) {
    if (isMobileWidth) {
        return MAX_DOCUMENTS_COUNT_MOBILE;
    }
    if (isLaptopWidth) {
        return MAX_DOCUMENTS_COUNT_LAPTOP;
    }
    return MAX_DOCUMENTS_COUNT;
}